import {AdminDevicesState} from './states/admin-devices.state';

export const adminDevicesState = [
    AdminDevicesState
];
